<!--
Copyright 2023 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">

  <div class="spacer">&nbsp;</div>

  <div class="user-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-group"></mat-icon>
        <p>Exhibit Users</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="teamUserFilterString" (keyup)="applyTeamUserFilter($event)" #teamUserInput autocomplete="off" />
          @if (teamUserFilterString) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearTeamUserFilter()">
            <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #teamUserPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    @if (false) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
    }

    <mat-table class="mat-table-all-users" #table [dataSource]="teamUserDataSource" matSort>
      <ng-container matColumnDef="team">
        <mat-header-cell *matHeaderCellDef>Team</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getTeamName(element.teamId) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getUserName(element.userId) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="addObserver(element.id)" style="outline: none;"
              title="Add {{ getUserName(element.userId) }}" [disabled]="!canEdit">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle-outline"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedTeamUserColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedTeamUserColumns"></mat-row>
    </mat-table>

    @if (teamUserDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>

  <div class="spacer">&nbsp;</div>

  <div class="observer-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-multiple"></mat-icon>
        <p>Observers</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="observerFilterString" (keyup)="applyObserverFilter($event)" #observerInput autocomplete="off" />
          @if (observerFilterString) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearObserverFilter()">
            <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #observerPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    @if (false) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
    }

    <mat-table class="mat-table-all-users" #table [dataSource]="observerDataSource" matSort>
      <ng-container matColumnDef="team">
        <mat-header-cell *matHeaderCellDef>Team</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getTeamName(element.teamId) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getUserName(element.userId) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="removeObserver(element.id)" style="outline: none;"
              title="Remove {{ getUserName(element.userId) }}" [disabled]="!canEdit">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-minus-circle-outline"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedObserverColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedObserverColumns"></mat-row>
    </mat-table>

    @if (observerDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>

  <div class="spacer">&nbsp;</div>

</div>
